<template>
  <v-card-text style="overflow-y: auto; height: auto">
    <v-row class="pt-10" justify="center">
      <span class="text-333333 w-700 font-18">แบบบันทึกและติดตามการเยี่ยมบ้าน</span>
    </v-row>
    <v-form ref="form4">
      <v-row class="pt-3">
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pb-2 w-700 font-16 text-333333 pr-3 pt-2" style="white-space: nowrap;">กิจกรรมการพยาบาล <span
              class="red--text">*</span></span>
          <v-row no-gutters>
            <span class="pb-2 w-500 font-16 text-333333 pr-3 pt-2" style="white-space: nowrap;">ครั้งที่</span>
            <v-row no-gutters>
              <v-text-field solo dense hide-details="auto" class="pb-2 pr-3" type="number" :min="1"
                v-model="nursing_activity_no.no" :rules="status == 'see' ? [] : rules_detail"
                :readonly="status == 'see'" @keypress="validateNumber" @input="validateZero"></v-text-field>
            </v-row>
            <span class="pb-2 w-500 font-16 text-333333 pr-3 pt-2" style="white-space: nowrap;">วันที่</span>
            <v-row no-gutters>
              <v-menu v-model="day_menu" :close-on-content-click="false" transition="scale-transition" offset-y bottom
                right hide-details="auto" :disabled="status == 'see'">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field solo dense append-icon="mdi-calendar-multiselect" placeholder="วัน/เดือน/ปี"
                    :value="displayDate()" readonly v-bind="attrs" hide-details v-on="on" class="pb-2 pr-3"
                    color="#00A99D" item-color="teal darken-2">
                    <template slot="append">
                      <v-btn text icon v-on="on" :readonly="status == 'see'">
                        <v-icon color="#00A99D">mdi-calendar-multiselect</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="nursing_activity_no.date" :max="dateNow" no-title scrollable locale="th"
                  @input="day_menu = false" color="#00A99D" :active-picker="activePicker" :readonly="status == 'see'">
                  <v-spacer></v-spacer>
                  <v-btn text color="#00A99D" @click="clearDaySelect">ล้างค่า/clear</v-btn>
                </v-date-picker>
              </v-menu>
            </v-row>
            <v-col cols="12" class="d-flex d-flex-row">
              <span class="pb-2 w-500 font-16 text-333333 pr-3 pt-2" style="white-space: nowrap;">เวลาที่เยี่ยมบ้าน <span
                class="red--text">*</span></span>
            <v-row no-gutters>
              <v-autocomplete :items="set_hour" solo dense placeholder="ชั่วโมง" hide-details="auto" color="#00A99D"
                item-color="teal darken-2" class="pb-2 pr-3" v-model="hour_start" style="max-width: 160px !important;"
                :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'">
              </v-autocomplete>
              <v-autocomplete :items="set_min" solo dense placeholder="นาที" hide-details="auto" color="#00A99D"
                item-color="teal darken-2" class="pb-2 pr-3" v-model="min_start" style="max-width: 160px !important;"
                :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'">
              </v-autocomplete>
              <span class="pb-2 w-500 font-16 text-333333 pr-3 pt-2"> น. </span>
            </v-row>

            <span class="pb-2 w-500 font-16 text-333333 pr-3 pt-2" style="white-space: nowrap;">เวลาที่สิ้นสุดการเยี่ยม
              <span class="red--text">*</span></span>
            <v-row no-gutters>
              <v-autocomplete :items="filteredHoursEnd" solo dense placeholder="ชั่วโมง" hide-details="auto" color="#00A99D"
                item-color="teal darken-2" class="pb-2 pr-3" v-model="hour_end" style="max-width: 160px !important;"
                :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'">
              </v-autocomplete>
              <v-autocomplete :items="filteredMinutesEnd" solo dense placeholder="นาที" hide-details="auto" color="#00A99D"
                item-color="teal darken-2" class="pb-2 pr-3" v-model="min_end" style="max-width: 160px !important;"
                :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'">
              </v-autocomplete>
              <span class="pb-2 w-500 font-16 pt-2"> น. </span>
            </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-0">
          <span class="w-700 font-16 text-333333">ประเภทผู้ป่วย</span>
        </v-col>
        <v-col cols="12" class="py-0 pl-6">
          <v-checkbox dense class="set-checkbox" v-model="patient_type.status" color="#00A99D"
            label="7001 กลุ่มผู้ป่วยที่สามารถรักษาหายได้" value="1" hide-details="auto"
            @click="patient_type.id = '7001', patient_type.title = 'กลุ่มผู้ป่วยที่สามารถรักษาหายได้'"
            :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'"></v-checkbox>
        </v-col>
        <v-col cols="12" class="py-0 pl-6">
          <v-checkbox dense class="set-checkbox" v-model="patient_type.status" color="#00A99D"
            label="7002 กลุ่มผู้ป่วยโรคเรื้อรังที่ไม่สามารถควบคุมอาการได้" value="2" hide-details="auto"
            @click="patient_type.id = '7002', patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังที่ไม่สามารถควบคุมอาการได้'"
            :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'"></v-checkbox>
        </v-col>
        <v-col cols="12" class="py-0 pl-6">
          <v-checkbox dense class="set-checkbox" v-model="patient_type.status" color="#00A99D"
            label="7003 กลุ่มผู้ป่วยโรคเรื้อรังและไร้ความสามารถเล็กน้อย" value="3" hide-details="auto"
            @click="patient_type.id = '7003', patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังและไร้ความสามารถเล็กน้อย'"
            :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'"></v-checkbox>
        </v-col>
      </v-row>
      <v-row class="pt-3">
        <v-col cols="12">
          <span class="w-700 font-16 text-333333">ข้อบ่งชี้/เหตุผลในการเยี่ยมบ้าน <span
              class="red--text">*</span></span>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-textarea solo dense hide-details="auto" placeholder="กรอกข้อบ่งชี้/เหตุผลในการเยี่ยมบ้าน"
            v-model="reason_visit_home" :rules="status == 'see' ? [] : rules_detail"
            :readonly="status == 'see'"></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="3" no-gutters class="pb-2 d-flex">
              <span class="pt-2 w-500 font-16 text-333333 pr-3">V/S T <span class="red--text">*</span></span>
              <v-text-field solo dense hide-details="auto" v-model="V_S.T.value_1" style="max-width: 100px !important;"
                :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'" type="number"
                @keypress="validateNumber"></v-text-field>
              <span class="pt-2 w-500 font-16 text-333333 px-3">C</span>
            </v-col>
            <v-col cols="4" no-gutters class="pb-2 d-flex">
              <span class="pt-2 w-500 font-16 text-333333 pr-3">BP (1) <span class="red--text">*</span></span>
              <v-text-field solo dense hide-details="auto" v-model="V_S.BP_1.value_1"
                style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
              <span class="pt-2 w-500 font-16 text-333333 px-3">/</span>
              <v-text-field solo dense hide-details="auto" v-model="V_S.BP_1.value_2"
                style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
              <span class="pt-2 w-500 font-16 text-333333 px-3">mm.Hg</span>
            </v-col>
            <v-col cols="4" no-gutters class="pb-2 d-flex">
              <span class="pt-2 w-500 font-16 text-333333 pr-3">BP (2) <span class="red--text">*</span></span>
              <v-text-field solo dense hide-details="auto" v-model="V_S.BP_2.value_1"
                style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
              <span class="pt-2 w-500 font-16 text-333333 px-3">/</span>
              <v-text-field solo dense hide-details="auto" v-model="V_S.BP_2.value_2"
                style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
              <span class="pt-2 w-500 font-16 text-333333 px-3">mm.Hg</span>
            </v-col>
            <v-row no-gutters class="pt-2">
              <v-col cols="3" no-gutters class="pb-2 d-flex">
                <span class="pt-2 w-500 font-16 text-333333 pr-3">RR <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" v-model="V_S.RR.value_1"
                  style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                  :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
                <span class="pt-2 w-500 font-16 text-333333 px-3">/min.</span>
              </v-col>
              <v-col cols="3" no-gutters class="pb-2 d-flex">
                <span class="pt-2 w-500 font-16 text-333333 pr-3">PR <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" v-model="V_S.PR.value_1"
                  style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                  :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
                <span class="pt-2 w-500 font-16 text-333333 px-3">/min.</span>
              </v-col>
              <v-col cols="3" no-gutters class="pb-2 d-flex">
                <span class="pt-2 w-500 font-16 text-333333 pr-3">BW <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" v-model="V_S.BW.value_1"
                  style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                  :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
                <span class="pt-2 w-500 font-16 text-333333 px-3">Kg</span>
              </v-col>
              <v-col cols="3" no-gutters class="pb-2 d-flex">
                <span class="pt-2 w-500 font-16 text-333333 pr-3">HT <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" v-model="V_S.HT.value_1"
                  style="max-width: 100px !important;" :rules="status == 'see' ? [] : rules_detail"
                  :readonly="status == 'see'" type="number" @keypress="validateNumber"></v-text-field>
                <span class="pt-2 w-500 font-16 text-333333 px-3">Cm</span>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pt-1 pr-6 w-500 font-16 text-333333 align-self-start">ประเมินสภาพทั่วไป <span
              class="red--text">*</span></span>
          <v-row no-gutters>
            <v-checkbox v-model="general_condition.status" color="#00A99D" label="เหมือนเดิม" value="1"
              hide-details="auto" dense class="pr-6 pt-0"
              @click="general_condition.title = 'เหมือนเดิม', general_condition.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'"></v-checkbox>
            <v-checkbox v-model="general_condition.status" color="#00A99D" label="เปลี่ยนแปลง" value="2"
              hide-details="auto" dense class="pr-6 pt-0"
              @click="general_condition.title = 'เปลี่ยนแปลง', general_condition.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'"></v-checkbox>

            <v-row no-gutters v-if="general_condition.status == '2'">
              <v-textarea solo dense hide-details="auto" placeholder="ระบุการเปลี่ยนแปลง" class="pt-2"
                v-model="general_condition.detail" :rules="status == 'see' ? [] : rules_detail"
                :readonly="status == 'see'"></v-textarea>
            </v-row>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mb-2 mr-0">
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="aad_problems_encountered()" icon>
              <v-icon color="#00A99D">mdi-plus-box</v-icon>
            </v-btn>
          </template>
          <span>เพิ่มปัญหาที่พบ</span>
        </v-tooltip>
      </v-row>
      <div v-if="display_vuetify !== 'xs'"
        style="min-height: 310px; max-height: 500px;overflow-x: hidden;overflow-y: auto;">
        <v-row v-for="(item, index) in problems" :key="index" class="pa-3">
          <v-col cols="11" class="pa-0">
            <v-row no-gutters>
              <span class="py-2 text-333333 font-18 w-700">รายการที่ {{ index + 1 }}. <span
                  class="red--text">*</span></span>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">ปัญหาที่พบ</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                    <v-textarea hide-details="auto" placeholder="ระบุปัญหาที่พบ" class="px-1 pt-0"
                      v-model="item.problems_encountered" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'" maxlength="300" counter></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">เป้าหมายการพยาบาล</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                    <v-textarea hide-details="auto" placeholder="ระบุเป้าหมายการพยาบาล" class="px-1 pt-0"
                      v-model="item.nursing_goals" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'" maxlength="300" counter></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">การพยาบาล/ช่วยเหลือ</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                    <v-textarea hide-details="auto" placeholder="ระบุการพยาบาล/ช่วยเหลือ" class="px-1 pt-0"
                      v-model="item.nursing" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'" maxlength="300" counter></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">ผลการพยาบาล/ประเมินผล</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                    <v-textarea hide-details="auto" placeholder="ระบุผลการพยาบาล/ประเมินผล" class="px-1 pt-0"
                      v-model="item.nursing_results" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'" maxlength="300" counter></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" align-self="center" class="pt-16 pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="delete_problems_encountered(index)" icon>
                  <v-icon color="#F5222D">mdi-minus-box</v-icon>
                </v-btn>
              </template>
              <span>ลบปัญหาที่พบ</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <v-row v-else>
        <v-col cols="12">
          <v-window reverse v-model="slide">
            <template v-slot:prev="{ on, attrs }">
              <v-btn fab x-small text v-bind="attrs" v-on="on" color="#00A99D" @click="prev"><v-icon
                  color="#00A99D">mdi-chevron-left</v-icon></v-btn>
            </template>
            <template v-slot:next="{ on, attrs }">
              <v-btn fab x-small v-bind="attrs" v-on="on" text color="#00A99D" @click="next"><v-icon
                  color="#00A99D">mdi-chevron-right</v-icon></v-btn>
            </template>
            <v-window-item v-for="(item, index) in problems" :key="index">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-row no-gutters>
                    <span class="py-2 text-333333 font-18 w-700">รายการที่ {{ index + 1 }} / {{ problems.length
                      }}</span>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" @click="delete_problems_encountered(index)" icon>
                          <v-icon color="#F5222D">mdi-minus-box</v-icon>
                        </v-btn>
                      </template>
                      <span>ลบปัญหาที่พบ</span>
                    </v-tooltip>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">ปัญหาที่พบ</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                          <v-textarea hide-details="auto" placeholder="ระบุปัญหาที่พบ" class="px-1 pt-0"
                            v-model="item.problems_encountered" color="#00A99D"
                            :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff"
                              style="white-space: nowrap;">เป้าหมายการพยาบาล</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white"
                          style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                          <v-textarea hide-details="auto" placeholder="ระบุเป้าหมายการพยาบาล" class="px-1 pt-0"
                            v-model="item.nursing_goals" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                            :readonly="status == 'see'"></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff"
                              style="white-space: nowrap;">การพยาบาล/ช่วยเหลือ</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white"
                          style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                          <v-textarea hide-details="auto" placeholder="ระบุการพยาบาล/ช่วยเหลือ" class="px-1 pt-0"
                            v-model="item.nursing" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                            :readonly="status == 'see'"></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff"
                              style="white-space: nowrap;">ผลการพยาบาล/ประเมินผล</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                          <v-textarea hide-details="auto" placeholder="ระบุผลการพยาบาล/ประเมินผล" class="px-1 pt-0"
                            v-model="item.nursing_results" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                            :readonly="status == 'see'"></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-item-group v-model="slide" class="text-center" mandatory>
                    <v-item v-for="n in problems.length" :key="`btn-${n}`" v-slot="{ active, toggle }">
                      <v-btn :input-value="active" icon @click="toggle" color="#00A99D" x-small>
                        <v-icon>mdi-record</v-icon>
                      </v-btn>
                    </v-item>
                  </v-item-group>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-5">
          <span class="w-700 font-16 text-333333">แผนการเยี่ยมครั้งต่อไป <span class="red--text">*</span></span>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-textarea solo dense hide-details="auto" placeholder="ระบุแผนการเยี่ยมครั้งต่อไป" v-model="next_visit_plans"
            class="mt-0" :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="w-700 font-16 text-333333 pr-6 pt-2">นัดครั้งต่อไป</span><span
            class="w-700 font-16 text-333333 pr-3 pt-2">วันที่</span>
          <v-menu v-model="day_menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="350px" min-width="auto" top right hide-details="auto" :disabled="status == 'see'">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field solo dense append-icon="mdi-calendar-multiselect" placeholder="วัน/เดือน/ปี"
                :value="displayDate2()" readonly v-bind="attrs" hide-details v-on="on" color="#00A99D"
                item-color="teal darken-2" style="max-width: 200px !important;">
                <template slot="append">
                  <v-btn text icon v-on="on" :readonly="status == 'see'">
                    <v-icon color="#00A99D">mdi-calendar-multiselect</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="next_visit_time" :min="date2" no-title scrollable locale="th"
              @input="day_menu2 = false" color="#00A99D" :active-picker="activePicker2" :readonly="status == 'see'">
              <v-spacer></v-spacer>
              <v-btn text color="#00A99D" @click="clearDaySelect2">ล้างค่า/clear</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="pt-5 d-flex d-flex-row">
        <v-col cols="12" xl="8" lg="8" md="6" sm="6" class="pb-8">
          <v-row>
            <v-col cols="9" xl="3" lg="3" md="6" class="py-0 pr-8 pl-10">
              <v-card outlined :disabled="status == 'see'"
                style="border: 2px solid #00A99D;border-style: dashed !important;">
                <v-card-title>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-tooltip
                      v-if="user.signature_user !== '' && user.signature_user !== null && user.signature_user !== undefined && edit == false"
                      bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="mr-2" fab x-small text depressed @click="edit = true"
                          :disabled="status == 'see'">
                          <v-icon size="30" color="#00A99D">mdi-pen</v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไข</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="mr-2" fab x-small text depressed :disabled="!isWrite"
                          @click="clearBack()">
                          <v-icon size="30"
                            :color="!isWrite || (user.signature_user !== '' && user.signature_user !== null && user.signature_user !== undefined && edit == false) ? '#333333' : '#00A99D'">mdi-replay</v-icon>
                        </v-btn>
                      </template>
                      <span>ย้อนกลับ</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab x-small text depressed :disabled="!isWrite"
                          @click="clearSign()">
                          <v-icon size="30"
                            :color="!isWrite || (user.signature_user !== '' && user.signature_user !== null && user.signature_user !== undefined && edit == false) ? '#333333' : '#EB5757'">mdi-cancel</v-icon>
                        </v-btn>
                      </template>
                      <span>ล้างค่า</span>
                    </v-tooltip>
                  </v-row>
                </v-card-title>

                <v-card-text
                  v-if="user.signature_user !== '' && user.signature_user !== null && user.signature_user !== undefined && edit == false">
                  <v-img :src="user.signature_user" width="100%" height="80px" />
                </v-card-text>

                <v-card-text v-else>
                  <VueSignaturePad width="100%" height="80px" ref="signatureUser" :options="{
                    onBegin: () => {
                      $refs.signatureUser.resizeCanvas();
                    },
                    onEnd,
                  }" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="py-0">
              <span
                class="w-700 font-16 text-333333">ลงชื่อ........................................................ผู้รับบริการ</span>
            </v-col>
            <v-col cols="12" class="py-0 pl-16">
              <span class="w-700 font-16 text-333333">( {{ user.name }} )</span>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" xl="4" lg="4" md="6" sm="6" class="pb-8">
          <v-row>
            <v-col cols="9" xl="6" lg="6" md="6" class="py-0 px-8" align="center">
              <v-card outlined :disabled="status == 'see'"
                style="border: 2px solid #00A99D;border-style: dashed !important;">
                <v-card-title>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-tooltip
                      v-if="staff_service.signature_staff !== '' && staff_service.signature_staff !== null && staff_service.signature_staff !== undefined && edit2 == false"
                      bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="mr-2" fab x-small text depressed @click="edit2 = true"
                          :disabled="status == 'see'">
                          <v-icon size="30" color="#00A99D">mdi-pen</v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไข</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="mr-2" fab x-small text depressed :disabled="!isWrite2"
                          @click="clearBack2()">
                          <v-icon size="30"
                            :color="!isWrite2 || (staff_service.signature_staff !== '' && staff_service.signature_staff !== null && staff_service.signature_staff !== undefined && edit2 == false) ? '#333333' : '#00A99D'">mdi-replay</v-icon>
                        </v-btn>
                      </template>
                      <span>ย้อนกลับ</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab x-small text depressed :disabled="!isWrite2"
                          @click="clearSign2()">
                          <v-icon size="30"
                            :color="!isWrite2 || (staff_service.signature_staff !== '' && staff_service.signature_staff !== null && staff_service.signature_staff !== undefined && edit2 == false) ? '#333333' : '#EB5757'">mdi-cancel</v-icon>
                        </v-btn>
                      </template>
                      <span>ล้างค่า</span>
                    </v-tooltip>
                  </v-row>
                </v-card-title>

                <v-card-text
                  v-if="staff_service.signature_staff !== '' && staff_service.signature_staff !== null && staff_service.signature_staff !== undefined && edit2 == false">
                  <v-img :src="staff_service.signature_staff" width="100%" height="80px" />
                </v-card-text>

                <v-card-text v-else>
                  <VueSignaturePad width="100%" height="80px" ref="signatureStaff" :options="{
                    onBegin: () => {
                      $refs.signatureStaff.resizeCanvas();
                    },
                    onEnd,
                  }" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="py-0">
              <span
                class="w-700 font-16 text-333333">ลงชื่อ........................................................ตำแหน่ง
                {{
                  staff_service.position }} ผู้เยี่ยม/ผู้รับผิดชอบ</span>
            </v-col>
            <v-col cols="12" class="py-0 pl-16">
              <span class="w-700 font-16 text-333333">( {{ staff_service.name }} )</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="pt-5">
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="w-700 font-16 text-333333">แนบเอกสารเพิ่มเติม</span>
          <v-row no-gutters>
            <v-file-input v-model="files" color="#00A99D" label="เพิ่มไฟล์" multiple prepend-icon="mdi-paperclip"
              outlined dense style="max-width: 1720px !important;" @change="saveFiles(files)"
              :disabled="status == 'see'">
              <template v-slot:selection="{ index, text }">
                <v-chip color="#00A99D" text-color="#FFFFFF" class="py-2 my-2" close
                  @click:close="files.splice(index, 1)" :readonly="status == 'see'">
                  {{ index + 1 }}. {{ files[index].filename }}{{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
</template>

<script>
import moment from "moment";

export default {
  props: ['status', 'data1', 'data2', 'appointment'],
  data() {
    return {
      day_menu: false,
      isWrite: false,
      isWrite2: false,
      dateNow: moment().format("YYYY-MM-DD"),
      activePicker: null,
      set_hour: [],
      set_min: [],
      hour_start: '',
      min_start: '',
      hour_end: '',
      min_end: '',
      day_menu2: false,
      date2: moment().add(1, 'days').format("YYYY-MM-DD"),
      activePicker2: null,
      slide: 0,
      edit: false,
      edit2: false,
      files: [],

      nursing_activity_no: {
        no: '',
        date: moment().format("YYYY-MM-DD"),
        visit_time: '',
        end_time: ''
      },
      patient_type: {
        status: '',
        id: '',
        title: ''
      },
      reason_visit_home: '',
      V_S: {
        T: {
          value_1: ''
        },
        BP_1: {
          value_1: '',
          value_2: ''
        },
        BP_2: {
          value_1: '',
          value_2: ''
        },
        RR: {
          value_1: ''
        },
        PR: {
          value_1: ''
        },
        BW: {
          value_1: ''
        },
        HT: {
          value_1: ''
        },
      },
      general_condition: {
        status: '',
        title: '',
        detail: ''
      },
      problems: [
        {
          problems_encountered: '',
          nursing_goals: '',
          nursing: '',
          nursing_results: ''
        }
      ],
      next_visit_plans: '',
      next_visit_time: moment().add(1, 'days').format("YYYY-MM-DD"),
      reciver_service_name: '',
      user: {
        name: '',
        one_id: '',
        signature_user: '',
        file_id_user_image: '',
      },
      staff_service: {
        name: sessionStorage.getItem('accountName'),
        position: sessionStorage.getItem('role_name'),
        signature_staff: '',
        file_id_staff_image: '',
      },
      rules_checkbox: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      rules_detail: [(v) => !!v || "กรุณาระบุข้อมูล"],
      user_image_HTML: "",
      staff_image_HTML: "",
    }
  },
  computed: {
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 820) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      },
    },
    phone() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width <= 820) {
        return true;
      } else {
        return false;
      }
    },
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    },
    filteredHoursEnd() {
      if (this.hour_start === null) 
       return this.set_hour;
      return this.set_hour.filter((hour) => hour >= this.hour_start);
    },
    filteredMinutesEnd() {
      if (this.hour_end === this.hour_start) {
        return this.set_min.filter((min) => min > this.min_start);
      }
      return this.set_min;
    },
  },
  watch: {
    data1(val) {
      if (val.general_info != undefined) {
        this.patient_type = {
          status: val.general_info.patient_type.status,
          id: val.general_info.patient_type.id,
        }

        if (val.general_info.patient_type.id == '7001') {
          this.patient_type.title = 'กลุ่มผู้ป่วยที่สามารถรักษาหายได้'
        } else if (val.general_info.patient_type.id == '7002') {
          this.patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังที่ไม่สามารถควบคุมอาการได้'
        } else if (val.general_info.patient_type.id == '7003') {
          this.patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังและไร้ความสามารถเล็กน้อย'
        }
      }
    },
    data2(val) {
      console.log("data2", val);
      if (val.examination != undefined && this.appointment == false) {
        this.V_S.T.value_1 = val.examination.V_S.T.value_1
        this.V_S.BP_1.value_1 = val.examination.V_S.BP.value_1
        this.V_S.BP_1.value_2 = val.examination.V_S.BP.value_2
        this.V_S.RR.value_1 = val.examination.V_S.RR.value_1
        this.V_S.PR.value_1 = val.examination.V_S.PR.value_1

        // this.V_S = {
        //   T: {
        //     value_1: val.examination.V_S.T.value_1
        //   },
        //   BP_1: {
        //     value_1: val.examination.V_S.BP.value_1,
        //     value_2: val.examination.V_S.BP.value_2
        //   },
        //   BP_2: {
        //     value_1: '',
        //     value_2: ''
        //   },
        //   RR: {
        //     value_1: val.examination.V_S.RR.value_1
        //   },
        //   PR: {
        //     value_1: val.examination.V_S.PR.value_1
        //   },
        //   BW: {
        //     value_1: ''
        //   },
        //   HT: {
        //     value_1: ''
        //   },
        // }
      }
    },
    hour_start(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.hour_end = "";
      }
    },
    min_start(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.min_end = "";
      }
    },
  },
  methods: {
    saveFiles(files) {
      console.log('files', files);
    },
    async openPage(item, home_visit) {
      // console.log('home_visit_recording page FollowUp', home_visit);
      // console.log('item page FollowUp', item);

      this.hour_start = home_visit !== null && 'nursing_activity_no' in home_visit && 'visit_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.visit_time !== '' && home_visit.nursing_activity_no.visit_time !== null && home_visit.nursing_activity_no.visit_time !== undefined ? home_visit.nursing_activity_no.visit_time.substring(0, 2) : ''
      this.min_start = home_visit !== null && 'nursing_activity_no' in home_visit && 'visit_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.visit_time !== '' && home_visit.nursing_activity_no.visit_time !== null && home_visit.nursing_activity_no.visit_time !== undefined ? home_visit.nursing_activity_no.visit_time.substring(3, 5) : ''
      this.hour_end = home_visit !== null && 'nursing_activity_no' in home_visit && 'end_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.end_time !== '' && home_visit.nursing_activity_no.end_time !== null && home_visit.nursing_activity_no.end_time !== undefined ? home_visit.nursing_activity_no.end_time.substring(0, 2) : ''
      this.min_end = home_visit !== null && 'nursing_activity_no' in home_visit && 'end_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.end_time !== '' && home_visit.nursing_activity_no.end_time !== null && home_visit.nursing_activity_no.end_time !== undefined ? home_visit.nursing_activity_no.end_time.substring(3, 5) : ''

      await this.set_value()

      this.nursing_activity_no = {
        no: home_visit !== null && 'nursing_activity_no' in home_visit && 'no' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.no !== '' && home_visit.nursing_activity_no.no !== null && home_visit.nursing_activity_no.no !== undefined ? home_visit.nursing_activity_no.no : '',
        date: home_visit !== null && 'nursing_activity_no' in home_visit && 'date' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.date !== '' && home_visit.nursing_activity_no.date !== null && home_visit.nursing_activity_no.date !== undefined ? home_visit.nursing_activity_no.date : moment().format("YYYY-MM-DD"),
        visit_time: home_visit !== null && 'nursing_activity_no' in home_visit && 'visit_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.visit_time !== '' && home_visit.nursing_activity_no.visit_time !== null && home_visit.nursing_activity_no.visit_time !== undefined ? home_visit.nursing_activity_no.visit_time : '',
        end_time: home_visit !== null && 'nursing_activity_no' in home_visit && 'end_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.end_time !== '' && home_visit.nursing_activity_no.end_time !== null && home_visit.nursing_activity_no.end_time !== undefined ? home_visit.nursing_activity_no.end_time : '',
      }

      this.patient_type = {
        status: home_visit !== null && 'patient_type' in home_visit && 'status' in home_visit.patient_type && home_visit.patient_type.status !== '' && home_visit.patient_type.status !== null && home_visit.patient_type.status !== undefined ? home_visit.patient_type.status : '',
        id: home_visit !== null && 'patient_type' in home_visit && 'id' in home_visit.patient_type && home_visit.patient_type.id !== '' && home_visit.patient_type.id !== null && home_visit.patient_type.id !== undefined ? home_visit.patient_type.id : '',
        title: home_visit !== null && 'patient_type' in home_visit && 'title' in home_visit.patient_type && home_visit.patient_type.title !== '' && home_visit.patient_type.title !== null && home_visit.patient_type.title !== undefined ? home_visit.patient_type.title : '',
      }

      this.reason_visit_home = home_visit !== null && 'reason_visit_home' in home_visit && home_visit.reason_visit_home !== '' && home_visit.reason_visit_home !== null && home_visit.reason_visit_home !== undefined ? home_visit.reason_visit_home : '',

        this.V_S = {
          T: {
            value_1: home_visit !== null && 'V_S' in home_visit && 'T' in home_visit.V_S && 'value_1' in home_visit.V_S.T && home_visit.V_S.T.value_1 !== '' && home_visit.V_S.T.value_1 !== null && home_visit.V_S.T.value_1 !== undefined ? home_visit.V_S.T.value_1 : ''
          },
          BP_1: {
            value_1: home_visit !== null && 'V_S' in home_visit && 'BP_1' in home_visit.V_S && 'value_1' in home_visit.V_S.BP_1 && home_visit.V_S.BP_1.value_1 !== '' && home_visit.V_S.BP_1.value_1 !== null && home_visit.V_S.BP_1.value_1 !== undefined ? home_visit.V_S.BP_1.value_1 : '',
            value_2: home_visit !== null && 'V_S' in home_visit && 'BP_1' in home_visit.V_S && 'value_2' in home_visit.V_S.BP_1 && home_visit.V_S.BP_1.value_2 !== '' && home_visit.V_S.BP_1.value_2 !== null && home_visit.V_S.BP_1.value_2 !== undefined ? home_visit.V_S.BP_1.value_2 : ''
          },
          BP_2: {
            value_1: home_visit !== null && 'V_S' in home_visit && 'BP_2' in home_visit.V_S && 'value_1' in home_visit.V_S.BP_2 && home_visit.V_S.BP_2.value_1 !== '' && home_visit.V_S.BP_2.value_1 !== null && home_visit.V_S.BP_2.value_1 !== undefined ? home_visit.V_S.BP_2.value_1 : '',
            value_2: home_visit !== null && 'V_S' in home_visit && 'BP_2' in home_visit.V_S && 'value_2' in home_visit.V_S.BP_2 && home_visit.V_S.BP_2.value_2 !== '' && home_visit.V_S.BP_2.value_2 !== null && home_visit.V_S.BP_2.value_2 !== undefined ? home_visit.V_S.BP_2.value_2 : ''
          },
          RR: {
            value_1: home_visit !== null && 'V_S' in home_visit && 'RR' in home_visit.V_S && 'value_1' in home_visit.V_S.RR && home_visit.V_S.RR.value_1 !== '' && home_visit.V_S.RR.value_1 !== null && home_visit.V_S.RR.value_1 !== undefined ? home_visit.V_S.RR.value_1 : '',
          },
          PR: {
            value_1: home_visit !== null && 'V_S' in home_visit && 'PR' in home_visit.V_S && 'value_1' in home_visit.V_S.PR && home_visit.V_S.PR.value_1 !== '' && home_visit.V_S.PR.value_1 !== null && home_visit.V_S.PR.value_1 !== undefined ? home_visit.V_S.PR.value_1 : '',
          },
          BW: {
            value_1: home_visit !== null && 'V_S' in home_visit && 'BW' in home_visit.V_S && 'value_1' in home_visit.V_S.BW && home_visit.V_S.BW.value_1 !== '' && home_visit.V_S.BW.value_1 !== null && home_visit.V_S.BW.value_1 !== undefined ? home_visit.V_S.BW.value_1 : '',
          },
          HT: {
            value_1: home_visit !== null && 'V_S' in home_visit && 'HT' in home_visit.V_S && 'value_1' in home_visit.V_S.HT && home_visit.V_S.HT.value_1 !== '' && home_visit.V_S.HT.value_1 !== null && home_visit.V_S.HT.value_1 !== undefined ? home_visit.V_S.HT.value_1 : '',
          },
        }

      this.general_condition = {
        status: home_visit !== null && 'general_condition' in home_visit && 'status' in home_visit.general_condition && home_visit.general_condition.status !== '' && home_visit.general_condition.status !== null && home_visit.general_condition.status !== undefined ? home_visit.general_condition.status : '',
        title: home_visit !== null && 'general_condition' in home_visit && 'title' in home_visit.general_condition && home_visit.general_condition.title !== '' && home_visit.general_condition.title !== null && home_visit.general_condition.title !== undefined ? home_visit.general_condition.title : '',
        detail: home_visit !== null && 'general_condition' in home_visit && 'detail' in home_visit.general_condition && home_visit.general_condition.detail !== '' && home_visit.general_condition.detail !== null && home_visit.general_condition.detail !== undefined ? home_visit.general_condition.detail : '',
      }

      this.problems = home_visit !== null && 'problems' in home_visit && home_visit.problems !== null && home_visit.problems.length !== 0 && home_visit.problems !== undefined ? home_visit.problems : this.problems = [{ problems_encountered: '', nursing_goals: '', nursing: '', nursing_results: '' }],
        // this.problems_encountered = 'problems_encountered' in home_visit && home_visit.problems_encountered !== '' && home_visit.problems_encountered !== null && home_visit.problems_encountered !== undefined ? home_visit.problems_encountered : '',
        // this.nursing_goals = 'nursing_goals' in home_visit && home_visit.nursing_goals !== '' && home_visit.nursing_goals !== null && home_visit.nursing_goals !== undefined ? home_visit.nursing_goals : '',
        // this.nursing = 'nursing' in home_visit && home_visit.nursing !== '' && home_visit.nursing !== null && home_visit.nursing !== undefined ? home_visit.nursing : '',
        // this.nursing_results = 'nursing_results' in home_visit && home_visit.nursing_results !== '' && home_visit.nursing_results !== null && home_visit.nursing_results !== undefined ? home_visit.nursing_results : '',
        this.next_visit_plans = home_visit !== null && 'next_visit_plans' in home_visit && home_visit.next_visit_plans !== '' && home_visit.next_visit_plans !== null && home_visit.next_visit_plans !== undefined ? home_visit.next_visit_plans : '',
        this.next_visit_time = home_visit !== null && 'next_visit_time' in home_visit && home_visit.next_visit_time !== '' && home_visit.next_visit_time !== null && home_visit.next_visit_time !== undefined ? home_visit.next_visit_time : moment().add(1, 'days').format("YYYY-MM-DD"),
        this.reciver_service_name = home_visit !== null && 'reciver_service_name' in home_visit && home_visit.reciver_service_name !== '' && home_visit.reciver_service_name !== null && home_visit.reciver_service_name !== undefined ? home_visit.reciver_service_name : '',

        this.user = {
          name: 'fullname' in item && item.fullname !== '' && item.fullname !== null && item.fullname !== undefined ? item.fullname : '',
          one_id: 'one_id' in item && item.one_id !== '' && item.one_id !== null && item.one_id !== undefined ? item.one_id : '',
          signature_user: home_visit !== null && 'user' in home_visit && 'signature_user' in home_visit.user && home_visit.user.signature_user !== '' && home_visit.user.signature_user !== null && home_visit.user.signature_user !== undefined ? home_visit.user.signature_user : '',
          file_id_user_image: home_visit !== null && 'user' in home_visit && 'file_id_user_image' in home_visit.user && home_visit.user.file_id_user_image !== '' && home_visit.user.file_id_user_image !== null && home_visit.user.file_id_user_image !== undefined ? home_visit.user.file_id_user_image : '',
        }

      this.staff_service = {
        name: sessionStorage.getItem('accountName'),
        position: sessionStorage.getItem('role_name'),
        signature_staff: home_visit !== null && 'staff_service' in home_visit && 'signature_staff' in home_visit.staff_service && home_visit.staff_service.signature_staff !== '' && home_visit.staff_service.signature_staff !== null && home_visit.staff_service.signature_staff !== undefined ? home_visit.staff_service.signature_staff : '',
        file_id_staff_image: home_visit !== null && 'staff_service' in home_visit && 'file_id_staff_image' in home_visit.staff_service && home_visit.staff_service.file_id_staff_image !== '' && home_visit.staff_service.file_id_staff_image !== null && home_visit.staff_service.file_id_staff_image !== undefined ? home_visit.staff_service.file_id_staff_image : '',
      }

      if (home_visit !== null && 'user' in home_visit && 'file_id_user_image' in home_visit.user && home_visit.user.file_id_user_image !== '' && home_visit.user.file_id_user_image !== null && home_visit.user.file_id_user_image !== undefined) {
        await this.get_img_onebox(home_visit.user.file_id_user_image, 'user')

        if (this.user_image_HTML !== '') {
          this.user.signature_user = this.user_image_HTML
        }
      } else {
        if (home_visit !== null && 'user' in home_visit && 'signature_user' in home_visit.user && home_visit.user.signature_user !== '' && home_visit.user.signature_user !== null && home_visit.user.signature_user !== undefined) {
          this.user.signature_user = home_visit.user.signature_user
          this.edit = false
        } else {
          this.user.signature_user = ''
          this.edit = true
        }
      }

      if (home_visit !== null && 'staff_service' in home_visit && 'file_id_staff_image' in home_visit.staff_service && home_visit.staff_service.file_id_staff_image !== '' && home_visit.staff_service.file_id_staff_image !== null && home_visit.staff_service.file_id_staff_image !== undefined) {
        await this.get_img_onebox(home_visit.staff_service.file_id_staff_image, 'staff')

        if (this.staff_image_HTML !== '') {
          this.staff_service.signature_staff = this.staff_image_HTML
        }
      } else {
        if (home_visit !== null && 'staff_service' in home_visit && 'signature_staff' in home_visit.staff_service && home_visit.staff_service.signature_staff !== '' && home_visit.staff_service.signature_staff !== null && home_visit.staff_service.signature_staff !== undefined) {
          this.staff_service.signature_staff = home_visit.staff_service.signature_staff
          this.edit2 = false
        } else {
          this.staff_service.signature_staff = ''
          this.edit2 = true
        }
      }

      this.$refs.form4.resetValidation()
    },
    async get_img_onebox(item, text) {
      try {
        const params = new URLSearchParams();
        params.append("file_id", item);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/download_home_visit_one_box?${params}`).then((res) => {
          console.log('onebox', res);
          if (res.data.result == 'success' && res.data.code == 200) {
            if (res.data.data !== '' && res.data.data !== null && res.data.data !== undefined) {
              if (text == 'user') {
                this.user_image_HTML = 'data:image/png;base64,' + res.data.data
                this.edit = false
              } else if (text == 'staff') {
                this.staff_image_HTML = 'data:image/png;base64,' + res.data.data
                this.edit2 = false
              }
            } else {
              if (text == 'user') {
                this.user_image_HTML = ''
                this.edit = true
              } else if (text == 'staff') {
                this.staff_image_HTML = ''
                this.edit2 = true
              }
            }
          }
        })
      } catch (err) {
        console.log(err);
      }
    },
    openFiles(files) {
      console.log('files.files', files);
      if (files.files.length !== 0 && files.files !== null && files.files !== undefined && files.files !== '') {
        this.files = files.files
      } else {
        this.files = []
      }
      // console.log('this.files', this.files);
    },
    async valid4(status) {
      // nursing_activity_no
      if (this.hour_start != '' && this.min_start != '') {
        this.nursing_activity_no.visit_time = this.hour_start + ':' + this.min_start
      }
      if (this.hour_end != '' && this.min_end != '') {
        this.nursing_activity_no.end_time = this.hour_end + ':' + this.min_end
      }

      // patient_type
      if (this.patient_type.status == null || this.patient_type.status == '') {
        this.patient_type = {
          status: '',
          id: '',
          title: ''
        }
      }

      // general_condition
      if (this.general_condition.status == null || this.general_condition.status == '') {
        this.general_condition = {
          status: '',
          title: '',
          detail: ''
        }
      }

      // user
      if ((this.edit == false || this.edit == true) && this.user.signature_user == '') {
        if (this.$refs.signatureUser.saveSignature().data !== undefined && this.$refs.signatureUser.saveSignature().data !== null && this.$refs.signatureUser.saveSignature().data !== '') {
          const { data } = this.$refs.signatureUser.saveSignature()
          this.user.signature_user = data
        } else {
          this.user.signature_user = ''
        }
      } else if (this.edit == true && this.user.signature_user !== '') {
        if (this.$refs.signatureUser.saveSignature().data !== undefined && this.$refs.signatureUser.saveSignature().data !== null && this.$refs.signatureUser.saveSignature().data !== '') {
          const { data } = this.$refs.signatureUser.saveSignature()
          this.user.signature_user = data
        } else {
          this.user.signature_user = ''
        }
      }

      // staff_service
      if ((this.edit2 == false || this.edit2 == true) && this.staff_service.signature_staff == '') {
        if (this.$refs.signatureStaff.saveSignature().data !== undefined && this.$refs.signatureStaff.saveSignature().data !== null && this.$refs.signatureStaff.saveSignature().data !== '') {
          const { data } = this.$refs.signatureStaff.saveSignature()
          this.staff_service.signature_staff = data
        } else {
          this.staff_service.signature_staff = ''
        }
      } else if (this.edit2 == true && this.staff_service.signature_staff !== '') {
        if (this.$refs.signatureStaff.saveSignature().data !== undefined && this.$refs.signatureStaff.saveSignature().data !== null && this.$refs.signatureStaff.saveSignature().data !== '') {
          const { data } = this.$refs.signatureStaff.saveSignature()
          this.staff_service.signature_staff = data
        } else {
          this.staff_service.signature_staff = ''
        }
      }

      var check_list_problems = []

      await this.problems.forEach(async (ele) => {
        if (ele.problems_encountered !== '' || ele.nursing_goals !== '' || ele.nursing !== '' || ele.nursing_results !== '') {
          await check_list_problems.push(ele)
        }
      });

      var data4 = {
        nursing_activity_no: this.nursing_activity_no,
        patient_type: this.patient_type,
        reason_visit_home: this.reason_visit_home,
        V_S: this.V_S,
        general_condition: this.general_condition,
        // problems_encountered: this.problems_encountered,
        // nursing_goals: this.nursing_goals,
        // nursing: this.nursing,
        // nursing_results: this.nursing_results,
        problems: check_list_problems,
        next_visit_plans: this.next_visit_plans,
        next_visit_time: this.next_visit_time,
        reciver_service_name: this.reciver_service_name,
        user: this.user,
        staff_service: this.staff_service
      }

      await this.$emit('data4', data4)
      await this.$emit('dataFiles4', this.files)

      if (status == 'finish') {
        if (this.$refs.form4.validate()) {
          this.$emit('valid4', false)
        } else {
          this.$emit('valid4', true)
        }
      } else if (status == '4page') {
        if (this.$refs.form4.validate()) {
          this.$emit('valid4', false)
        } else {
          this.$emit('valid4', true)
        }
      }
    },
    next() {
      this.slide = this.slide + 1 === this.problems.length ? 0 : this.slide + 1
    },
    prev() {
      this.slide = this.slide - 1 < 0 ? this.problems.length - 1 : this.slide - 1
    },
    set_value() {
      this.set_hour.push('00')
      for (var i = 1; i <= 23; i++) {
        if (i < 10) {
          this.set_hour.push('0' + i.toString())
        } else {
          this.set_hour.push(i.toString())
        }
      }
      this.set_min.push('00')
      for (var j = 1; j <= 59; j++) {
        if (j < 10) {
          this.set_min.push('0' + j.toString())
        } else {
          this.set_min.push(j.toString())
        }
      }
    },
    displayDate() {
      var year1 = ""
      var year2 = ""
      if (!this.nursing_activity_no.date) return;
      year1 = moment(this.nursing_activity_no.date).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(this.nursing_activity_no.date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect() {
      this.nursing_activity_no.date = null;
      this.day_menu = false;
      this.activePicker = null
    },
    displayDate2() {
      var year11 = ""
      var year22 = ""
      if (!this.next_visit_time) return;
      year11 = moment(this.next_visit_time).locale("th").format("YYYY")
      year22 = (parseInt(year11) + 543).toString()
      return moment(this.next_visit_time).locale("th").format("DD/MM/" + year22)
    },
    clearDaySelect2() {
      this.next_visit_time = null;
      this.day_menu2 = false;
      this.activePicker2 = null
    },
    onEnd() {
      // console.log("onEnd");
      // console.log("this.$refs.signatureUser.saveSignature()", this.$refs.signatureUser);
      if ((this.user.signature_user == '' || this.user.signature_user == null || this.user.signature_user == undefined) && this.edit == false) {
        const { isEmpty } = this.$refs.signatureUser.saveSignature();
        if (isEmpty === false) {
          this.isWrite = true;
        } else {
          this.isWrite = false;
        }
      } else if ((this.user.signature_user !== '' || this.user.signature_user !== null || this.user.signature_user !== undefined) && this.edit == true) {
        const { isEmpty } = this.$refs.signatureUser.saveSignature();
        if (isEmpty === false) {
          this.isWrite = true;
        } else {
          this.isWrite = false;
        }
      }

      // console.log("this.$refs.signatureStaff.saveSignature()", this.$refs.signatureStaff.resizeCanvas);
      if ((this.staff_service.signature_staff == '' || this.staff_service.signature_staff == null || this.staff_service.signature_staff == undefined) && this.edit2 == false) {
        const { isEmpty } = this.$refs.signatureStaff.saveSignature();
        if (isEmpty === false) {
          this.isWrite2 = true;
        } else {
          this.isWrite2 = false;
        }
      } else if ((this.staff_service.signature_staff !== '' || this.staff_service.signature_staff !== null || this.staff_service.signature_staff !== undefined) && this.edit2 == true) {
        const { isEmpty } = this.$refs.signatureStaff.saveSignature();
        if (isEmpty === false) {
          this.isWrite2 = true;
        } else {
          this.isWrite2 = false;
        }
      }
    },
    clearSign() {
      this.$refs.signatureUser.clearSignature();
      this.isWrite = false;
    },
    clearBack() {
      const { isEmpty } = this.$refs.signatureUser.saveSignature();
      // console.log('isEmpty',this.$refs.signatureUser.getPropImagesAndCacheImages());
      if (isEmpty === true) {
        this.isWrite = false;
      } else {
        this.$refs.signatureUser.undoSignature();
      }
    },
    clearSign2() {
      this.$refs.signatureStaff.clearSignature();
      this.isWrite2 = false;
    },
    clearBack2() {
      const { isEmpty } = this.$refs.signatureStaff.saveSignature();
      // console.log('isEmpty',this.$refs.signatureStaff.getPropImagesAndCacheImages());
      if (isEmpty === true) {
        this.isWrite2 = false;
      } else {
        this.$refs.signatureStaff.undoSignature();
      }
    },
    aad_problems_encountered() {
      if (this.status !== 'see') {
        if (this.display_vuetify == 'xs') {
          this.slide = this.problems.length
        }

        this.problems.push({
          problems_encountered: '',
          nursing_goals: '',
          nursing: '',
          nursing_results: ''
        })
      }
    },
    delete_problems_encountered(index) {
      if (this.status !== 'see') {
        if (this.problems.length === 1) {
          this.problems = [{
            problems_encountered: '',
            nursing_goals: '',
            nursing: '',
            nursing_results: ''
          }]
        } else {
          this.problems.splice(index, 1);
        }
      }
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        event.preventDefault();
      }
    },
    validateZero(value) {
      if (value === "0") {
        this.nursing_activity_no.no = "1";
      }
    },
  }
}
</script>

<style scoped>
::v-deep .set-checkbox .v-input--selection-controls__input {
  align-self: start !important;
}

.border-card-00A99D {
  border: 2px solid #00A99D;
}

::v-deep .v-slide-group__content {
  justify-content: center !important;
}

::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled>.v-input__control>.v-input__slot fieldset {
  /* color: #fff; */
  background: #ffffff;
}
/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button, 
::v-deep input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
    -moz-appearance: textfield;
}
</style>